<div class="flex flex-col w-full h-full">
  <div
    class="flex flex-row justify-between items-center py-[16px] px-[24px] w-full border-b-[thin] border-color-light-shade border-solid border-x-0 border-t-0"
  >
    <div class="flex flex-row items-center gap-3">
      <div class="flex justify-center items-center w-9 h-9 rounded-full bg-color-primary bg-opacity-[8%]">
        <icons-component iconName="assetsTree" fill="#002266"></icons-component>
      </div>
      <p class="font-medium text-2xl text-color-neutral m-0 p-0">{{ 'ASSETS_TREE.HEADER.TITLE' | translate }}</p>
    </div>

    <div position="right-4" class="flex flex-row justify-center items-center gap-2">
      @if (assetsTreeFilterService.isFiltering()) {
        <palantir-button
          theme="outline"
          position="right-4"
          size="base"
          layout="icon"
          icon="filter-off-filled"
          palantirTooltip="{{ 'ASSETS_TREE.HEADER.FILTER' | translate }}"
          (click)="assetsTreeFilterService.clearFilters()"
        >
        </palantir-button>
      }

      <palantir-button
        theme="outline"
        position="right-4"
        size="base"
        layout="icon"
        icon="filter-filled"
        palantirTooltip="{{ 'ASSETS_TREE.HEADER.FILTER' | translate }}"
        (click)="openFilterAssetsTree()"
      >
      </palantir-button>

      <fc-menu theme="solid" [title]="'ASSETS_TREE.HEADER.ADD_ASSET.TITLE' | translate">
        <fc-menu-option
          [icon]="'location_on'"
          [text]="'ASSETS_TREE.HEADER.ADD_ASSET.OPTIONS.LOCATION' | translate"
          [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
          [disabled]="!hasLocationCreatePermission"
          (clickEvent)="openCreateLocationDialog()"
          [isFirst]="true"
        ></fc-menu-option>

        <fc-menu-option
          [icon]="'precision_manufacturing'"
          [text]="'ASSETS_TREE.HEADER.ADD_ASSET.OPTIONS.EQUIPMENT' | translate"
          [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
          [disabled]="!hasEquipmentCreatePermission"
          (clickEvent)="openCreateEquipmentDialog()"
          [isLast]="true"
        ></fc-menu-option>
      </fc-menu>
    </div>
  </div>

  @if (assetsTreeFilterService.isEmpty()) {
    <div class="w-full h-full flex flex-col justify-center items-center gap-8">
      <img src="assets/images/icons/no-assets.svg" alt="no assets" />
      <div>
        <p class="font-medium text-base text-color-normal text-center m-0 p-0 pb-3">{{ 'ASSETS_TREE.NO_ASSETS.TITLE' | translate }}</p>
        <p class="font-medium text-sm text-color-secondary text-center m-0 p-0">
          {{ 'ASSETS_TREE.NO_ASSETS.DESCRIPTION' | translate }}
        </p>
      </div>
      <fc-menu theme="outline" position="left-0" [title]="'ASSETS_TREE.HEADER.ADD_ASSET.TITLE' | translate">
        <fc-menu-option
          [icon]="'location_on'"
          [text]="'ASSETS_TREE.HEADER.ADD_ASSET.OPTIONS.LOCATION' | translate"
          [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
          [disabled]="!hasLocationCreatePermission"
          (clickEvent)="openCreateLocationDialog()"
          [isFirst]="true"
        ></fc-menu-option>
        <fc-menu-option
          [icon]="'precision_manufacturing'"
          [text]="'ASSETS_TREE.HEADER.ADD_ASSET.OPTIONS.EQUIPMENT' | translate"
          [tooltipText]="'ASSETS_TREE.NO_PERMISSION' | translate"
          [disabled]="!hasEquipmentCreatePermission"
          (clickEvent)="openCreateEquipmentDialog()"
          [isLast]="true"
        ></fc-menu-option>
      </fc-menu>
    </div>
  }

  @if (!assetsTreeFilterService.isEmpty()) {
    <div class="w-full h-full flex flex-row">
      <div class="w-full grow">
        <app-tree-section></app-tree-section>
      </div>
      @if (showDetailsBody()) {
        <div class="w-[400px] flex-none" [@fadeInOut]>
          <app-details-section></app-details-section>
        </div>
      }
    </div>
  }
</div>
